import { PromptsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { llmPromptsKeys } from 'app/queries/llmPrompts/llmPromptsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof llmPromptsKeys.prompts>>;

export const createFetchPromptsQueryFn =
  (call: TCall) =>
  async ({ signal }: TParams) =>
    (await call(() => cancelOnSignal(PromptsService.getAll(), signal))) ?? [];
